import { NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  RdsCellDefDirective,
  RdsCellDirective,
  RdsColumnDefDirective,
  RdsHeaderCellDefDirective,
  RdsHeaderCellDirective,
  RdsHeaderRowComponent,
  RdsHeaderRowDefDirective,
  RdsIconButtonComponent,
  RdsIconComponent,
  RdsRadioButtonComponent,
  RdsRowComponent,
  RdsRowDefDirective,
  RdsTableComponent,
  RdsTableDataSource,
} from '@rds/angular-components';

import { RoomLayoutsModel } from '@bookly/shared';

export interface LayoutEditEvent {
  layout: RoomLayoutsModel;
}

@Component({
  selector: 'bad-layout-table',
  imports: [
    RdsIconComponent,
    NgOptimizedImage,
    RdsTableComponent,
    RdsColumnDefDirective,
    RdsHeaderCellDirective,
    RdsHeaderCellDefDirective,
    RdsCellDefDirective,
    RdsCellDirective,
    RdsRadioButtonComponent,
    RdsIconButtonComponent,
    RdsHeaderRowComponent,
    RdsHeaderRowDefDirective,
    RdsRowComponent,
    RdsRowDefDirective,
  ],
  templateUrl: './layout-table.component.html',
  styleUrl: './layout-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutTableComponent {
  @Input() public set roomLayout(value: RoomLayoutsModel[] | null) {
    if (value && value.length > 0) {
      this.dataSource.data = value.filter(layout => layout.active);
    }
  }
  @Input() public defaultLayout: string | null | undefined = null;
  @Output() public selectedLayout = new EventEmitter<string>();
  @Output() public removeLayout = new EventEmitter<string>();
  @Output() public editLayout = new EventEmitter<LayoutEditEvent>();

  protected readonly dataSource = new RdsTableDataSource<RoomLayoutsModel>(
    []
  ).init();
  displayedColumns: (keyof RoomLayoutsModel | 'default' | 'actions')[] = [
    'default',
    'imageUrl',
    'layoutName',
    'capacity',
    'setupTime',
    'actions',
  ];

  protected selectLayout(roomLayout: string) {
    this.selectedLayout.emit(roomLayout);
  }

  protected deleteLayout(layoutId: string) {
    this.removeLayout.emit(layoutId);
  }

  protected editLayoutHandler(layout: RoomLayoutsModel) {
    this.editLayout.emit({ layout });
  }
}
